import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setSearchTerm } from '../data/actions/config.actions';
import { getSearchTerm, getFilteredConfig } from '../data/selectors/config.selectors';
import { Input } from 'reactstrap';
import { Search } from 'react-feather';
import { List } from 'immutable';


class NhpSearch extends React.Component {

  state = {focus: ''}

  handleFocus = () => this.setFocus(true);

  handleBlur = (e) => {
    if (!e.relatedTarget || !e.relatedTarget.parentNode || !e.relatedTarget.parentNode.parentNode || e.relatedTarget.parentNode.parentNode.id !== 'search') {
      this.setFocus(false);
    }
  }

  setFocus = (focused) => this.setState({focus: focused})

  handleChange = (e) => {
    this.props.setSearchTerm(e.target.value);
  }

  searchResult = (menuItem) =>
    menuItem.get('content', List()).map((i) => this.searchResultItem(menuItem, i))

  searchResultItem = (menuItem, item) =>
    <a key={item.get('name')}
      href={item.get('url')}
      rel="noopener noreferrer" target='_blank'
      className="d-flex flex-row align-items-center justify-content-between"
    >
      <div>
        {menuItem.get('name')}
      </div>
      <div>
        <img src={item.get('image')} alt={item.get('name')}/>
      </div>
    </a>

  searchResults = () =>
    <div className={(this.state.focus ? '' : 'd-none ') + "search-results"}>
      {this.props.filteredConfig.map((c) => this.searchResult(c))}
    </div>

  searchClassNames = () => `d-flex flex-row ${this.state.focus ? 'focus' : ''}`

  render = () =>
    <div id="search" className={this.searchClassNames()}>
      <Search className="side-nav-icon" />
      <span><Input onFocus={this.handleFocus} onBlurCapture={this.handleBlur} onChange={this.handleChange}/></span>
      {this.props.searchTerm ? this.searchResults() : null }
    </div>
}

const mapStateToProps = state => ({
  searchTerm: getSearchTerm(state),
  filteredConfig : getFilteredConfig(state),
});

const mapDispatchToProps = dispatch => ({
  setSearchTerm: (searchTerm) => dispatch(setSearchTerm(searchTerm)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NhpSearch))
